import apiClient from './apiClient';
import type {
  AdminOverviewData,
  DailyActivityPoint,
  FarmAnalyticsData,
  UserSearchResponse,
  UserSearchParams,
  UserDetailData,
  BulkStatusRequest,
  BulkStatusResponse,
  FarmPurgePreview,
  FarmPurgeResult,
} from '@/types/admin';

const adminService = {
  getOverview(): Promise<AdminOverviewData> {
    return apiClient.get<AdminOverviewData>('/admin/dashboard/overview');
  },

  getUserActivity(periodDays = 30): Promise<DailyActivityPoint[]> {
    return apiClient.get<DailyActivityPoint[]>(
      `/admin/dashboard/user-activity?period_days=${periodDays}`
    );
  },

  getFarmAnalytics(locale = 'en'): Promise<FarmAnalyticsData> {
    return apiClient.get<FarmAnalyticsData>(
      `/admin/dashboard/farm-analytics?locale=${locale}`
    );
  },

  searchUsers(params: UserSearchParams): Promise<UserSearchResponse> {
    const searchParams = new URLSearchParams();
    if (params.search) searchParams.set('search', params.search);
    if (params.role) searchParams.set('role', params.role);
    if (params.status) searchParams.set('status', params.status);
    if (params.sort_by) searchParams.set('sort_by', params.sort_by);
    if (params.sort_dir) searchParams.set('sort_dir', params.sort_dir);
    if (params.skip !== undefined) searchParams.set('skip', String(params.skip));
    if (params.limit !== undefined) searchParams.set('limit', String(params.limit));
    return apiClient.get<UserSearchResponse>(`/admin/users/search?${searchParams.toString()}`);
  },

  getUserDetail(userId: number): Promise<UserDetailData> {
    return apiClient.get<UserDetailData>(`/admin/users/${userId}/detail`);
  },

  bulkUpdateStatus(data: BulkStatusRequest): Promise<BulkStatusResponse> {
    return apiClient.post<BulkStatusResponse>('/admin/users/bulk-status', data);
  },

  farmPurgePreview(farmId: string): Promise<FarmPurgePreview> {
    return apiClient.get<FarmPurgePreview>(`/admin/farms/${farmId}/purge-preview`);
  },

  /** Irreversible: removes an archived farm and everything under it. */
  purgeFarm(farmId: string, confirmName: string): Promise<FarmPurgeResult> {
    return apiClient.post<FarmPurgeResult>(`/admin/farms/${farmId}/purge`, { confirm_name: confirmName });
  },
};

export default adminService;
